import { showError } from "../../../shared/helper/messages";
import { getSeguro, getSeguroPromise, postSeguroPromise } from "../../../shared/helper/requests";
import { downloadArquivos } from '../../../shared/helper/impressao'
import { getCpf } from "../../../shared/helper/infoUsuario";
import { launch } from '../../../shared/helper/serviceLauncher';
import { SIGLA_SERVICO_REVISAR_BENEFICIO_POR_INCAPACIDADE, SIGLA_SSERVICO_PERICIA_PRESENCIAL_POR_NAO_CONFIRMACAO_DOCUMENTACAO_MEDICA } from "../selecaoServicos/siglaServico";
import { requestLaunchSagService } from "../../../painel/actions";
import store from "../../../store";
import { resetMiToken } from "login/actions";
import history from '../../../history';

const MSG_ERRO_COMPROVATE_PEDIDO = "Ocorreu um erro ao buscar o comprovante do Pedido. Tente de novo mais tarde.";
const MSG_ERRO_RELATORIO_PEDIDO = 'Ocorreu um erro ao buscar o relatório do Pedido. Tente de novo mais tarde.'

export const iniciarConsultaTarefas = () => ({
  type: 'REQUERIMENTO_CONSULTA_INICIAR_TAREFAS'
});

export const fimConsultaTarefas = () => ({
  type: 'REQUERIMENTO_CONSULTA_FIM_TAREFAS'
});

export const iniciarConsultaAgendamentos = () => ({
  type: 'REQUERIMENTO_CONSULTA_INICIAR_AGENDAMENTO'
});

export const iniciarConsultaAgendamentosBI = () => ({
  type: 'REQUERIMENTO_CONSULTA_INICIAR_AGENDAMENTO_BI'
});

export const consultarTarefasSucesso = (dados, cacheDefault) => {

  if (cacheDefault) {
    localStorage.setItem(obterNomeItemCache('tfData'), JSON.stringify(dados));
    let dataExpiracao = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem(obterNomeItemCache('tfDataExp'), dataExpiracao);
  }
  else {
    localStorage.setItem(obterNomeItemCache('tfBIData'), JSON.stringify(dados));
    let dataExpiracao = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem(obterNomeItemCache('tfBIDataExp'), dataExpiracao);
  }

  return {
    type: 'REQUERIMENTO_CONSULTA_TAREFA_SUCESSO',
    payload: dados
  }
}

export const consultarTarefasSucessoCache = dados => {
  return {
    type: 'REQUERIMENTO_CONSULTA_TAREFA_SUCESSO',
    payload: dados
  }
}

export const consultarTarefasErro = error => {
  //showError('Alguma consulta de requerimentos falhou.');
  return {
    type: "REQUERIMENTO_CONSULTA_TAREFA_ERRO",
    payload: error
  }
}

export const limparCachePedidos = () => {
  localStorage.removeItem(obterNomeItemCache('tfData'));
  localStorage.removeItem(obterNomeItemCache('tfDataExp'));
  localStorage.removeItem(obterNomeItemCache("agData"));
  localStorage.removeItem(obterNomeItemCache("agDataExp"));
  localStorage.removeItem(obterNomeItemCache("agBIDataExp"));
  localStorage.removeItem(obterNomeItemCache("agBIData"));
}

export const consultarTarefas = () => {
  const tarefasCacheName = obterNomeItemCache('tfData');
  const tarefasCacheExpName = obterNomeItemCache('tfDataExp');
  let tarefasCache = tarefasCacheName ? localStorage.getItem(tarefasCacheName) : null;
  let tarefasCacheExp = tarefasCacheExpName ? localStorage.getItem(tarefasCacheExpName) : null;
  if (tarefasCache && tarefasCacheExp && verificarValidadeCache(JSON.parse(tarefasCacheExp))) { // cache é válido
    console.debug("consultarTarefas cache", tarefasCache)
    return dispatch => {
      dispatch(iniciarConsultaTarefas());
      return dispatch(consultarTarefasSucessoCache(JSON.parse(tarefasCache)));
    }
  } else { // cache expirado ou cache ausente
    return dispatch => {
      dispatch(iniciarConsultaTarefas());
      return getSeguro(dispatch,
        'SagService/tarefa',
        (dados) => consultarTarefasSucesso(dados, true),
        consultarTarefasErro);
    }
  }
}

export const consultarTarefasPorServico = (siglasServicos, force = false) => {
  const tarefasCache = JSON.parse(localStorage.getItem(obterNomeItemCache('tfBIData')));
  const tarefasCacheExp = JSON.parse(localStorage.getItem(obterNomeItemCache('tfBIDataExp')));
  if (!force && tarefasCacheExp && verificarValidadeCache(tarefasCacheExp)) { // cache é válido
    return dispatch => {
      dispatch(iniciarConsultaTarefas());
      return dispatch(consultarTarefasSucessoCache(tarefasCache));
    }
  } else {
    return dispatch => {
      dispatch(iniciarConsultaTarefas());
      return getSeguro(dispatch,
        `SagService/tarefa?siglasServicos=${siglasServicos}`,
        (dados) => consultarTarefasSucesso(dados, false),
        consultarTarefasErro);
    }
  }
}

export const consultarAgendamentoSucesso = dados => {
  console.debug("consultarAgendamentoSucesso", dados)
  localStorage.setItem(obterNomeItemCache('agData'), JSON.stringify(dados));
  let dataExpiracao = new Date().getTime() + 24 * 60 * 60 * 1000;
  localStorage.setItem(obterNomeItemCache('agDataExp'), dataExpiracao);
  return {
    type: 'REQUERIMENTO_CONSULTA_AGENDAMENTO_SUCESSO',
    payload: dados
  }
}

export const consultarAgendamentoSucessoCache = dados => {
  return {
    type: 'REQUERIMENTO_CONSULTA_AGENDAMENTO_SUCESSO',
    payload: dados
  }
}

export const consultarAgendamentoErro = error => {
  //showError('Alguma consulta de requerimentos falhou.');
  return {
    type: "REQUERIMENTO_CONSULTA_AGENDAMENTO_ERRO",
    payload: error
  }
}

export const consultarAgendamentoBISucesso = dados => {
  console.debug("consultarAgendamentoBISucesso", dados)
  if(dados){
    localStorage.setItem(obterNomeItemCache('agBIData'), JSON.stringify(dados));
    let dataExpiracao = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem(obterNomeItemCache('agBIDataExp'), dataExpiracao);
  }
  return {
    type: 'REQUERIMENTO_CONSULTA_AGENDAMENTO_BI_SUCESSO',
    payload: dados
  }
}

export const consultarAgendamentoBISucessoCache = dados => {
  return {
    type: 'REQUERIMENTO_CONSULTA_AGENDAMENTO_BI_SUCESSO',
    payload: dados
  }
}

export const consultarAgendamentoPMFErro = error => {
  //showError('Alguma consulta de requerimentos falhou.');
  return {
    type: "REQUERIMENTO_CONSULTA_AGENDAMENTO_BI_ERRO",
    payload: error
  }
}

const removerCacheOutrosUsuarios = () => {
  let cpf = getCpf();
  let item;
  for (item in localStorage) {
    if (!localStorage.hasOwnProperty(item)) {
      continue;
    }
    if ((item.startsWith('agData') || item.startsWith('agBIData') || item.startsWith('tfData') || item.startsWith('tfBIData')) && !item.endsWith(cpf)) {
      localStorage.removeItem(item);
    }
  }
}

export const removerCachePedidosUsuario = () => {
  let cpf = getCpf();
  let item;
  for (item in localStorage) {
    if (!localStorage.hasOwnProperty(item)) {
      continue;
    }
    if ((item.startsWith('dtTfData') || item.startsWith('tfData') || item.startsWith('tfBIData')
      || item.startsWith('dtAgData') || item.startsWith('agData') || item.startsWith('agBIData'))
      && item.endsWith(cpf)) {
      localStorage.removeItem(item);
    }
  }
};

export const removerCachePedidosUsuarioLimpandoEstado = () => {
  removerCachePedidosUsuario();
  return [
    consultarTarefasSucessoCache([]),
    consultarAgendamentoSucessoCache([]),
    consultarAgendamentoBISucessoCache([])
  ];
}

export const verificarValidadeCache = (validadeDataCache) => {
  let isValido = true;
  let dataAtual = new Date().getTime();
  if (dataAtual > validadeDataCache) {
    isValido = false;
  }
  return isValido;
}

export const obterNomeItemCache = (tipoCache) => {
  let cpf = getCpf();
  return tipoCache + cpf;
}

export const consultarAgendamentos = () => {
  removerCacheOutrosUsuarios();
  const agendamentosCacheName = obterNomeItemCache('agData');
  const agendamentosCacheExpName = obterNomeItemCache('agDataExp')
  let agendamentosCache = agendamentosCacheName ? localStorage.getItem(agendamentosCacheName) : null;
  let agendamentosCacheExp = agendamentosCacheExpName ? localStorage.getItem(agendamentosCacheExpName) : null;
  if (agendamentosCache && agendamentosCacheExp && verificarValidadeCache(JSON.parse(agendamentosCacheExp))) { // cache é válido
    console.debug("consultarAgendamentos cache", agendamentosCache)
    return dispatch => {
      dispatch(iniciarConsultaAgendamentos());
      return dispatch(consultarAgendamentoSucessoCache(JSON.parse(agendamentosCache)));
    }
  } else { // cache expirado ou cache ausente
    return dispatch => {
      dispatch(iniciarConsultaAgendamentos());
      return getSeguro(dispatch, `SagService/agendamento/v2`,
        consultarAgendamentoSucesso, consultarAgendamentoErro);
    }
  }
}

export const setFilterStatus = value => ({
  type: 'REQUERIMENTO_CONSULTA_FILTER_STATUS',
  payload: value === null ? { id: 1, label: 'Todos', status: null } : value
})

export const setFilterProtocolo = value => ({
  type: 'REQUERIMENTO_CONSULTA_FILTER_PROTOCOLO',
  payload: value
})

const iniciaComprovante = () => ({
  type: 'REQUERIMENTO_CONSULTA_INICIA_COMPROVANTE'
})

export const comprovanteAgendamentoSucesso = (dados, protocolo) => {
  const nomeFinal = `comprovante-${String(protocolo)}.pdf`
  let msg = downloadArquivos(dados, nomeFinal);
  return msg ?
    showError(msg) :
    { type: "REQUERIMENTO_CONSULTA_COMPROVANTE_AGENDAMENTO_SUCESSO" }
}

export const comprovanteAgendamentoErro = erro => {
  let mensagem = undefined;
  if (erro && erro.response && erro.response.status === 400) {
    if (erro.response.data && erro.response.data.message) {
      mensagem = erro.response.data.message;
    }
  }
  //showError(mensagem ? mensagem : erro);
  return {
    type: "REQUERIMENTO_CONSULTA_COMPROVANTE_AGENDAMENTO_ERROR",
    payload: mensagem ? mensagem : MSG_ERRO_COMPROVATE_PEDIDO
  }
}

export const comprovanteAgendamento = (requerimento, nomeArquivo) => {
  return dispatch => {
    dispatch(iniciaComprovante());
    return getSeguro(
      dispatch,
      `SagService/agendamento/v2/${requerimento.id}/comprovante`,
      (dados) => comprovanteAgendamentoSucesso(dados, requerimento.protocolo),
      comprovanteAgendamentoErro
    );
  }
}

export const comprovanteTarefaSucesso = (dados, nomeArquivo, protocolo) => {
  const nomeFinal = `comprovante-${String(protocolo)}.pdf`
  let msg = downloadArquivos(dados, nomeFinal);
  return msg ?
    showError(msg) :
    { type: "REQUERIMENTO_CONSULTA_COMPROVANTE_TAREFA_SUCESSO" }
}

export const comprovanteTarefaErro = erro => {
  let mensagem = undefined;
  if (erro && erro.response && erro.response.status === 400) {
    if (erro.response.data && erro.response.data.message) {
      mensagem = erro.response.data.message;
    }
  }
  //showError(mensagem ? mensagem : erro);
  return {
    type: "REQUERIMENTO_CONSULTA_COMPROVANTE_TAREFA_ERROR",
    payload: mensagem ? mensagem : MSG_ERRO_COMPROVATE_PEDIDO
  }
}

export const comprovanteTarefa = (requerimento, nomeArquivo) => {
  return dispatch => {
    dispatch(iniciaComprovante());
    return getSeguro(
      dispatch,
      `SagService/tarefa/${requerimento.protocolo}/comprovante`,
      (dados) => comprovanteTarefaSucesso(dados, nomeArquivo, requerimento.protocolo),
      comprovanteTarefaErro
    );
  }
}

export const comprovanteTarefaPorProtocolo = protocolo => {
  return dispatch => {
    dispatch(iniciaComprovante());
    return getSeguro(
      dispatch,
      `SagService/tarefa/${protocolo}/comprovante`,
      comprovanteTarefaSucesso,
      comprovanteTarefaErro
    );
  }
}

export const relatorioTarefa = (protocolo, nomeArquivo) => {
  return dispatch => {
    dispatch(iniciaComprovante());
    return getSeguro(
      dispatch,
      `consolidadorservices/pap/${protocolo}`,
      (dados) => relatorioTarefaSucesso(dados, protocolo, nomeArquivo),
      relatorioTarefaErro
    )
  }
}

export const relatorioTarefaSucesso = (dados, protocolo, nomeArquivo)  => {
  const nomeFinal = `processo-${String(protocolo)}.pdf`
  let msg = downloadArquivos(dados, nomeFinal);
  return msg ?
    showError(msg) :
    { type: "REQUERIMENTO_CONSULTA_RELATORIO_TAREFA_SUCESSO" }
}

export const relatorioTarefaErro = erro => {
  let mensagem = undefined;
  if (erro && erro.response && erro.response.status === 400) {
    if (erro.response.data && erro.response.data.message) {
      mensagem = erro.response.data.message;
    }
  }
  if (!mensagem) {
    mensagem = MSG_ERRO_RELATORIO_PEDIDO
  }
  //showError(mensagem ? mensagem : erro);
  return {
    type: "REQUERIMENTO_CONSULTA_RELATORIO_TAREFA_ERROR",
    payload: mensagem ? mensagem : erro
  }
}

export const detalharTarefa = (protocolo, exigencia = false) => {
  let detalhar = {
    oldVersionService: "Detalhar Pedido",
    rootPath: exigencia ? `/agenda/detalharTarefa/${protocolo}/true`
      : `/agenda/detalharTarefa/${protocolo}`
  }
  launch(detalhar);
}

/**
 * Redirecinar para a v3.5.
 * @param {*} servicoTO 
 */
export const redirecionarServicosLegadosBI = (servicoTO, origemClick="") => {
  let sigla = servicoTO.sigla;

  switch (sigla) {
    case SIGLA_SSERVICO_PERICIA_PRESENCIAL_POR_NAO_CONFIRMACAO_DOCUMENTACAO_MEDICA:
      let redirectACONFDOC = {
        oldVersionService: "reqper",
        rootPath: `/reqper?sigla=${sigla}`
      }
      launch(redirectACONFDOC);
      break;
    case SIGLA_SERVICO_REVISAR_BENEFICIO_POR_INCAPACIDADE:
      store.dispatch(requestLaunchSagService(servicoTO, origemClick));
      history.replace("/carregar-requerimento-sag");
      break;
    default:
  }

}


export const ocultarAvisoCumprirExigencia = () => ({
  type: "REQUERIMENTO_CONSULTA_OCULTAR_AVISO_EXIGENCIA"
});

export const exibirAvisoCumprirExigencia = requerimento => ({
  type: "REQUERIMENTO_CONSULTA_EXIBIR_AVISO_EXIGENCIA",
  payload: requerimento
});

export const consultarAgendamentosPMFFiltrandoServico = (
  cpf,
  siglaServico
) => {
  const url = `PericiaService/agendamento/v2?cpf=${cpf}&siglaServico=${siglaServico}`;
  return (dispatch) => {
    return getSeguroPromise(url);
  };
};

export const consultarAgendamentosPMF = (
  cpf, protocoloInss
) => {
  let url = `PericiaService/agendamento/v2?cpf=${cpf}`;
  if (protocoloInss) {
    url = `${url}&protocoloInss=${protocoloInss}`;
  }
  return (dispatch) => {
    return getSeguroPromise(url);
  };
};


export const consultarAgendamentosBI = (cpf, protocoloInss) => {
  removerCacheOutrosUsuarios();

  const agendamentosCacheExpRaw = localStorage.getItem(obterNomeItemCache('agBIDataExp'));
  const agendamentosCacheRaw = localStorage.getItem(obterNomeItemCache('agBIData'));

  if (agendamentosCacheExpRaw && agendamentosCacheRaw) {
    const agendamentosCache = JSON.parse(agendamentosCacheRaw);
    const agendamentosCacheExp = JSON.parse(agendamentosCacheExpRaw);
    if (agendamentosCacheExp && verificarValidadeCache(agendamentosCacheExp)) {
      console.debug("Utilizando Agendamentos PMF do cache:", agendamentosCache)
      // Retorna uma Promise simulando a mesma estrutura do getSeguroPromise
      return new Promise((resolve) => {
        setTimeout(() => resolve({data: agendamentosCache}), 0);
      });
    }
  }
  // Cache expirado ou ausente, faz requisição para buscar os dados
  let url = `PericiaService/agendamento/v2?cpf=${cpf}`;
  if (protocoloInss) {
    url += `&protocoloInss=${protocoloInss}`;
  }

  return getSeguroPromise(url);
};


const iniciaLaudoPericia = () => ({
  type: 'REQUERIMENTO_CONSULTA_INICIA_LAUDO'
})

export const baixarDocLaudoPericia = protocolo => {
  return dispatch => {
    dispatch(iniciaLaudoPericia());
    return getSeguro(
      dispatch,
      `consolidadorservices/laudo-pericia/${protocolo}`,
      relatorioLaudoPericiaSucesso,
      relatorioLaudoPericiaErro
    )
  }
}

export const relatorioLaudoPericiaSucesso = dados => {
  if (!dados) {
    return [showError('Não foi encontrada informação de laudo para a perícia.'), {
      type: "REQUERIMENTO_CONSULTA_RELATORIO_LAUDO_ERROR"
    }]
  }
  let msg = downloadArquivos(dados, 'relatorio.pdf');
  return msg ?
    showError(msg) :
    { type: "REQUERIMENTO_CONSULTA_RELATORIO_LAUDO_SUCESSO" }
}

export const relatorioLaudoPericiaErro = erro => {
  let mensagem = undefined;
  if (erro && erro.response && erro.response.status === 400) {
    if (erro.response.data && erro.response.data.message) {
      mensagem = erro.response.data.message;
    }
  }
  return [showError(mensagem ? mensagem : 'Não foi possível consultar as informações de laudo. Tente novamente mais tarde.'), {
    type: "REQUERIMENTO_CONSULTA_RELATORIO_LAUDO_ERROR",
    payload: mensagem ? mensagem : erro
  }]
}

export const refreshTarefas = () => dispatch => {
  limparCachePedidos();
  dispatch(resetMiToken());
  return {
    type: 'REQUERIMENTO_CONSULTA_REFRESH_TAREFAS'
  }
}

export const resetReduxRequerimentoConsulta = () => {
  return {
    type: 'REQUERIMENTO_CONSULTA_RESET_REDUX'
  }
}

export function obterAgendamentosAVS() {
  return getSeguroPromise(`SagService/agendamento/v2`);
}

export const obterAgendamentosPMF = (
  cpf, protocoloInss
) => {
  let url = `PericiaService/agendamento/v2?cpf=${cpf}&protocoloInss=${protocoloInss}`;
  return getSeguroPromise(url);
};

export const resetErros = () => ({
  type: 'REQUERIMENTO_CONSULTA_RESET_ERROS'
})

export const limpaMensagem = () => ({
  type: 'LIMPA_MENSAGEM_REQUERIMENTO_CONSULTA'
})